'use client';
import styled from 'styled-components';

export const StyledTipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 960px;
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const TipsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.background.lightest};
  padding: ${({ theme }) => theme.spacing(6)};
  ${({ theme }) => theme.fontFamily.base}
  max-width: none;
  width: 100%;
`;

export const TipsCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.tabletL} {
    flex-direction: row;
  }
`;

export const TipCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: none;
  &:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }

  @media ${({ theme }) => theme.tabletL} {
    max-width: 200px;
  }
`;

export const TipCardContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;

  @media ${({ theme }) => theme.tabletL} {
    flex-direction: column;
    text-align: center;
  }
`;

export const DesktopTitleWrapper = styled.div`
  display: none;
  @media ${({ theme }) => theme.tabletL} {
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export const MobileTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  @media ${({ theme }) => theme.tabletL} {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  border-radius: ${({ theme }) => theme.spacing(4)};
  object-fit: fill;
  overflow: hidden;
  max-width: 80px;
  width: 100%;
  margin-right: ${({ theme }) => theme.spacing(2)};
  img {
    width: 100%;
    border-radius: 16px;
  }

  @media ${({ theme }) => theme.tabletL} {
    max-width: 152px;
    margin-right: 0;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.heading5}
  font-weight: bold;
`;

export const Content = styled.div`
  ${({ theme }) => theme.typography.body}
`;
